module.exports = __webpack_public_path__ + "static/img/sec1-slide-img01.c5ebf64.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/sec1-slide-img01.png
// module id = dt8l
// module chunks = 0